import React from 'react';

import * as styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../utils/handlers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class CardBottomButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      label: props.label
    };
  }

  onClick = e => {
    // Key-off labelInProgress value for whether or not we want to change labels according to result of a promise
    if (!this.props.labelInProgress) {
      return this.props.handleClick();
    }
    this.setState({ label: this.props.labelInProgress });
    return Promise.resolve(this.props.handleClick())
      .then(() => {
        this.setState({ label: this.props.labelSuccess || StringConstantsMixin.strings.SUCCESS });
      })
      .catch(e => {
        console.error(e);
        this.setState({ label: this.props.labelFailed || StringConstantsMixin.strings.FAILED });
      });
  };

  render() {
    const label = this.state.label;
    return (
      <span className={styles.button} title={label} onClick={wrapEventHandler(this.onClick)}>
        {label}
      </span>
    );
  }
}

export default CardBottomButton;
